import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";

function ResetConfirmDialog({ open, onClose, onConfirm, message }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>Reset Password</DialogTitle>
            <DialogContent>
                <SoftTypography>
                    {message}
                </SoftTypography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <SoftButton
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                >
                    Yes
                </SoftButton>
            </DialogActions>
        </Dialog>
    );
}

ResetConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
};

export default ResetConfirmDialog;


